module.exports = __webpack_public_path__ + "static/img/qiangchai.93d0c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/qiangchai.png
// module id = AwBr
// module chunks = 24